// import React from "react";
// import {
//   findObjectUseCase,
//   getObjectUseCase,
//   upsertUseCase,
// } from "../../../../usecases/object";
// import withRouter from "../../../../withRouter";
// import BaseFormPage from "../../../../base/BaseFormPage";
// import NavBar from "../../../../components/navigation";
// import InputFactory from "../../../../components/InputFactory";
// import SearchSelect from "../../../../components/searchSelect/SearchSelect";
// import JobPostingFormPresenter from "./JobPostingFormPresenter";
// import Hierarchy from "../../../../components/common/Hierarchy";

// class JobPostingFormPage extends BaseFormPage {
//   constructor(props) {
//     super(props);
//     this.state = {
//       hierarchy: {},
//       advanced: false,
//       positionTitle: [],
//       salaryGrade: [],
//       selectedTitle: "",
//       item_number: "",
//       selectedSalary: {},
//       typeApplication: "",
//       typeApplicant: "",
//       compensation: "",
//       education: "",
//       eligibility: "",
//       experience: "",
//       training: "",
//       generalscopeofwork: "",
//       qualificationstandard: "",
//       dutiesandresponsibilities: "",
//       corecompetencies: "",
//       organizationalcompetencies: "",
//       leadershipcompetencies: "",
//       technicalcompetencies: "",
//       otherqualifications: "",
//       deadlineofsubmission: undefined,
//     };
//     this.presenter = new JobPostingFormPresenter(
//       this,
//       getObjectUseCase(),
//       upsertUseCase()
//     );
//   }

//   getCollectionName() {
//     return "job_postings";
//   }

//   async componentDidMount() {
//     this.presenter.componentDidMount();
//     const positionTitle = await findObjectUseCase().execute("position_titles", {
//       include: ["salaryPointer"],
//     });
//     const salaryGrade = await findObjectUseCase().execute("salary_grade");
//     // const office = await findObjectUseCase().execute("offices");
//     // const division = await findObjectUseCase().execute("Division");

//     this.setState({ positionTitle, salaryGrade });
//   }

//   dateFormat(data) {
//     if (data !== undefined) {
//       return new Date(data).toISOString().split("T")[0];
//     } else {
//       return "";
//     }
//   }

//   componentDidUpdate(prevProps, prevState) {
//     if (prevState.object !== this.state.object) {
//       const { submissionDeadline, positionTitle, ...rest } = this.state.object;
//       // console.warn("data: ", submissionDeadline);
//       // const formattedDeadline = new Date(submissionDeadline)
//       //   .toISOString()
//       //   .split("T")[0];
//       const formattedDeadline = this.dateFormat(submissionDeadline);
//       this.setState({
//         ...rest,
//         selectedTitle: positionTitle,
//         deadlineofsubmission: formattedDeadline,
//         hierarchy: this.state.object,
//       });
//     }
//   }

//   onClickAdvance() {
//     this.setState((prevState) => ({ advanced: !prevState.advanced }));
//   }

//   async handleSelectedTitle(selectedTitle) {
//     console.log("TITLE: ", selectedTitle);
//     const selected = this.state.positionTitle.find(
//       (data) => data.position_title === selectedTitle?.position_title
//     );
//     console.log("SELECTED: ", selected);
//     const hierarchy = {
//       region: selected?.region,
//       office: selected?.office,
//       division: selected?.division,
//       section: selected?.section,
//       unit: selected?.unit,
//       cluster: selected?.cluster,
//     };
//     if (selected) {
//       this.setState({
//         selectedTitle,
//         item_number: selected?.item_number,
//         selectedSalary: selected?.salaryPointer,
//         compensation: selected?.other_compensation,
//         education: selected?.education,
//         eligibility: selected?.eligibility,
//         experience: selected?.experience,
//         training: selected?.training,
//         hierarchy,
//       });
//     } else {
//       this.setState({
//         selectedTitle,
//         item_number: "",
//         selectedSalary: "",
//         compensation: "",
//         education: "",
//         eligibility: "",
//         experience: "",
//         training: "",
//         hierarchy,
//       });
//     }

//     console.warn("selc: ", selected);
//   }

//   handleInputChange = (field) => (value) => {
//     console.log("field", field, "value", value);
//     if (field === "selectedSalary") {
//       console.log("Value: ", value);
//       this.setState({ [field]: value });
//     }
//     this.setState({ [field]: value });
//   };

//   handleObjectChange(hierarchy) {
//     const object = {
//       region: hierarchy.selectedregions,
//       office: hierarchy.selectedoffices,
//       division: hierarchy.selecteddivisions,
//       section: hierarchy.selectedsections,
//       unit: hierarchy.selectedunits,
//       cluster: hierarchy.selectedplantilla,
//     };
//     // this.setObject(...object);
//     this.setState({ hierarchy: object });
//   }

//   render() {
//     const {
//       selectedTitle,
//       positionTitle,
//       salaryGrade,
//       selectedSalary,
//       item_number,
//       compensation,
//       typeApplication,
//       typeApplicant,
//       object,
//       // office,
//       // selectedOffice,
//       // division,
//       // selectedDivision,
//     } = this.state;
//     console.log("OBJECT: ", typeApplicant, "hey", this.state);
//     const getTitle = positionTitle.filter((pt) => pt.id == selectedTitle.id);
//     console.log("getTitle", getTitle);
//     const schema = this.getSchema(this.getCollectionName());
//     const label = this.getObjectId() === undefined ? "Add New" : "Update ";
//     if (!schema) return <h1>no schema</h1>;
//     return (
//       <>
//         <div className="overflow-auto mt-5">
//           <div className="h-100">
//             <div className="p-3 p-lg-4">
//               <h1 className="fw-bold mt-3 text-capitalize">
//                 {(schema.label || this.getCollectionName()) + " Details"}
//               </h1>
//               <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
//                 <form
//                   onSubmit={(e) => {
//                     e.preventDefault();
//                     this.presenter.submitBtn();
//                   }}
//                 >
//                   <div className="row g-3">
//                     <div className="row p-3">
//                       <div className="col-lg-6 mb-4">
//                         <label style={{ fontSize: "14px" }}>
//                           Position Title <span className="text-danger">*</span>
//                         </label>
//                         <SearchSelect
//                           required
//                           focus={true}
//                           value={getTitle[0]?.position_title}
//                           onChange={this.handleSelectedTitle.bind(this)}
//                           onClickClear={() => this.handleSelectedTitle("")}
//                           options={positionTitle.map((title) => ({
//                             label: title.position_title,
//                             value: {
//                               position_title: title.position_title,
//                               id: title.id,
//                             },
//                           }))}
//                         />
//                       </div>
//                       <div className="col-lg-6 mb-4">
//                         <label style={{ fontSize: "14px" }}>Slots</label>
//                         <InputFactory
//                           type="String"
//                           field="itemNumber"
//                           value={item_number}
//                           onChange={this.handleInputChange("item_number")}
//                         />
//                       </div>
//                       <div className="col-lg-6 mb-4">
//                         <label style={{ fontSize: "14px" }}>Salary Grade</label>
//                         <SearchSelect
//                           value={selectedSalary.name}
//                           onChange={this.handleInputChange("selectedSalary")}
//                           options={salaryGrade.map((salary) => ({
//                             label: salary.name,
//                             value: { name: salary.name, id: salary.id },
//                           }))}
//                         />
//                       </div>
//                       <div className="col-lg-6 mb-4">
//                         <label style={{ fontSize: "14px" }}>
//                           Type of Applicant
//                         </label>
//                         <InputFactory
//                           type="String"
//                           _type="Enum"
//                           options={[
//                             "Hiring",
//                             "Job Order",
//                             "Organic",
//                             "Contractual",
//                           ]}
//                           field="typeApplicant"
//                           values={typeApplicant}
//                           onChange={this.handleInputChange("typeApplicant")}
//                         />
//                       </div>
//                       <div className="col-lg-6 mb-4">
//                         <label style={{ fontSize: "14px" }}>
//                           Compensation Package
//                         </label>
//                         <InputFactory
//                           type="Text"
//                           field="compensation"
//                           value={compensation}
//                           onChange={this.handleInputChange("compensation")}
//                         />
//                       </div>
//                       <div
//                         style={{
//                           marginLeft: "5px",
//                           paddingRight: "25px",
//                           marginBottom: "2rem",
//                         }}
//                       >
//                         <Hierarchy
//                           className="col-lg-6 p-2"
//                           object={this.state.hierarchy}
//                           handleObjectChange={this.handleObjectChange.bind(
//                             this
//                           )}
//                         />
//                       </div>
//                       <label>Qualification Standard</label>
//                       <hr />
//                       {[
//                         "Education",
//                         "Eligibility",
//                         "Experience",
//                         "Training",
//                       ].map((label, index) => (
//                         <div className="col-lg-6 mb-4" key={index}>
//                           <label style={{ fontSize: "14px" }}>{label}</label>
//                           <InputFactory
//                             type={
//                               label === "Deadline of Submission"
//                                 ? "Date"
//                                 : "Text"
//                             }
//                             field={label.replace(/\s+/g, "").toLowerCase()}
//                             value={
//                               this.state[
//                                 label.replace(/\s+/g, "").toLowerCase()
//                               ]
//                             }
//                             onChange={(value) =>
//                               this.handleInputChange(
//                                 label.replace(/\s+/g, "").toLowerCase()
//                               )(value)
//                             }
//                           />
//                         </div>
//                       ))}
//                       <hr />
//                       {/* break */}
//                       {[
//                         // "General Scope of Work",
//                         // "Qualification Standard",
//                         // "Duties and Responsibilities",
//                         // "Core Competencies",
//                         // "Organizational Competencies",
//                         // "Leadership Competencies",
//                         // "Technical Competencies",
//                         "Publication",
//                         "Reposting",
//                         "Other Qualifications",
//                         "Deadline of Submission",
//                       ].map((label, index) => (
//                         <div className="col-lg-6 mb-4" key={index}>
//                           <label style={{ fontSize: "14px" }}>
//                             {label}{" "}
//                             {label !== "Other Qualifications" && (
//                               <span className="text-danger">*</span>
//                             )}
//                           </label>
//                           <InputFactory
//                             type={
//                               label === "Deadline of Submission"
//                                 ? "Date"
//                                 : label === "Other Qualifications"
//                                 ? "Text"
//                                 : "String"
//                             }
//                             field={label.replace(/\s+/g, "").toLowerCase()}
//                             required={label !== "Other Qualifications"}
//                             value={
//                               this.state[
//                                 label.replace(/\s+/g, "").toLowerCase()
//                               ]
//                             }
//                             onChange={(value) =>
//                               this.handleInputChange(
//                                 label.replace(/\s+/g, "").toLowerCase()
//                               )(value)
//                             }
//                           />
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                   <div>
//                     <button
//                       className="btn btn-primary fs-sm me-3"
//                       // onClick={this.submitBtn.bind(this)}
//                       type="submit"
//                     >
//                       <i className="bi bi-file-earmark-check me-2"></i>
//                       {label}
//                     </button>
//                     <button
//                       type="button"
//                       className="btn btn-light fs-sm"
//                       onClick={this.onClickBack.bind(this)}
//                     >
//                       GO BACK
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>
//       </>
//     );
//   }
// }

// export default withRouter(JobPostingFormPage);

import React from "react";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import JobPostingFormPresenter from "./JobPostingFormPresenter";
import Hierarchy from "../../../../components/common/Hierarchy";
import FormFactory from "../../../../components/FormFactory";

class JobPostingFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      hierarchy: {},
      advanced: false,
      positionTitle: [],
      salaryGrade: [],
      selectedTitle: "",
      item_number: "",
      selectedSalary: {},
      typeApplication: "",
      typeApplicant: "",
      compensation: "",
      education: "",
      eligibility: "",
      experience: "",
      training: "",
      generalscopeofwork: "",
      qualificationstandard: "",
      dutiesandresponsibilities: "",
      corecompetencies: "",
      organizationalcompetencies: "",
      leadershipcompetencies: "",
      technicalcompetencies: "",
      otherqualifications: "",
      deadlineofsubmission: undefined,
    };
    this.presenter = new JobPostingFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "job_postings";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const positionTitle = await findObjectUseCase().execute("position_titles", {
      include: ["salaryPointer"],
    });
    const salaryGrade = await findObjectUseCase().execute("salary_grade");
    // const office = await findObjectUseCase().execute("offices");
    // const division = await findObjectUseCase().execute("Division");

    this.setState({ positionTitle, salaryGrade });
  }

  dateFormat(data) {
    if (data !== undefined) {
      return new Date(data).toISOString().split("T")[0];
    } else {
      return "";
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      const { submissionDeadline, positionTitle, ...rest } = this.state.object;
      // console.warn("data: ", submissionDeadline);
      // const formattedDeadline = new Date(submissionDeadline)
      //   .toISOString()
      //   .split("T")[0];
      const formattedDeadline = this.dateFormat(submissionDeadline);
      this.setState({
        ...rest,
        selectedTitle: positionTitle,
        deadlineofsubmission: formattedDeadline,
        hierarchy: this.state.object,
      });
    }
  }

  onClickAdvance() {
    this.setState((prevState) => ({ advanced: !prevState.advanced }));
  }

  async handleSelectedTitle(selectedTitle) {
    console.log("TITLE: ", selectedTitle);
    const selected = this.state.positionTitle.find(
      (data) => data.position_title === selectedTitle?.position_title
    );
    console.log("SELECTED: ", selected);
    const hierarchy = {
      region: selected?.region,
      office: selected?.office,
      division: selected?.division,
      section: selected?.section,
      unit: selected?.unit,
      cluster: selected?.cluster,
    };
    if (selected) {
      this.setState({
        selectedTitle,
        item_number: selected?.item_number,
        selectedSalary: selected?.salaryPointer,
        compensation: selected?.other_compensation,
        education: selected?.education,
        eligibility: selected?.eligibility,
        experience: selected?.experience,
        training: selected?.training,
        hierarchy,
      });
    } else {
      this.setState({
        selectedTitle,
        item_number: "",
        selectedSalary: "",
        compensation: "",
        education: "",
        eligibility: "",
        experience: "",
        training: "",
        hierarchy,
      });
    }

    console.warn("selc: ", selected);
  }

  handleInputChange = (field) => (value) => {
    console.log("field", field, "value", value);
    if (field === "selectedSalary") {
      console.log("Value: ", value);
      this.setState({ [field]: value });
    }
    this.setState({ [field]: value });
  };

  handleObjectChange(hierarchy) {
    const object = {
      region: hierarchy.selectedregions,
      office: hierarchy.selectedoffices,
      division: hierarchy.selecteddivisions,
      section: hierarchy.selectedsections,
      unit: hierarchy.selectedunits,
      cluster: hierarchy.selectedplantilla,
    };
    // this.setObject(...object);
    this.setState({ hierarchy: object });
  }

  render() {
    const { object } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Add New" : "Update ";
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h1 className="fw-bold mt-3 text-capitalize">
                {(schema.label || this.getCollectionName()) + " Details"}
              </h1>
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.presenter.save();
                  }}
                >
                  <div className="row">
                    <FormFactory
                      schema={schema}
                      className="col-lg-12 mb-2"
                      object={object}
                      onChange={this.onChange.bind(this)}
                      excludeFields={[]}
                    />
                  </div>
                  <div className="mt-4">
                    <button
                      className="btn btn-primary fs-sm me-3"
                      // onClick={this.submitBtn.bind(this)}
                      type="submit"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(JobPostingFormPage);
